import React from 'react';
import {Box, Button, Collapse, Grid, InputAdornment, TextField, Typography} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import {makeStyles} from '@material-ui/core/styles';
import {WEIGHT_DEFAULTS_PCT, WEIGHT_FIELDS} from './constants';

const useStyles = makeStyles((theme) => ({
    customLabel: {
        marginLeft: theme.spacing(0.75),
    },
    summaryRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    warning: {
        color: theme.palette.warning.main,
    },
}));

interface WeightsPanelProps {
    open: boolean;
    onToggle: () => void;
    values: Record<string, number>;
    onChange: (key: string, raw: string) => void;
    onReset: () => void;
    disabled?: boolean;
}

export default function WeightsPanel({open, onToggle, values, onChange, onReset, disabled}: WeightsPanelProps) {
    const classes = useStyles();
    const hasCustom = Object.entries(values).some(([k, v]) => v !== WEIGHT_DEFAULTS_PCT[k]);
    const total = Object.values(values).reduce((s, v) => s + v, 0);
    return (
        <>
            <Button size="small" onClick={onToggle} endIcon={open ? <ExpandLessIcon/> : <ExpandMoreIcon/>}>
                Gewichtung anpassen
                {hasCustom && (
                    <Typography component="span" variant="caption" color="textSecondary" className={classes.customLabel}>
                        (angepasst)
                    </Typography>
                )}
            </Button>
            <Collapse in={open} timeout="auto">
                <Box mt={2}>
                    <Grid container spacing={2}>
                        {WEIGHT_FIELDS.map((f) => (
                            <Grid item xs={6} md={3} key={f.key}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label={f.label}
                                    type="number"
                                    disabled={disabled}
                                    inputProps={{min: 0, max: 100, step: 5}}
                                    value={values[f.key]}
                                    onChange={(e) => onChange(f.key, e.target.value)}
                                    InputProps={{endAdornment: <InputAdornment position="end">%</InputAdornment>}}
                                />
                            </Grid>
                        ))}
                        <Grid item xs={12}>
                            <Box className={classes.summaryRow}>
                                <Typography variant="body2" className={total === 100 ? undefined : classes.warning}>
                                    Summe: {total} %
                                </Typography>
                                {hasCustom && (
                                    <Button size="small" onClick={onReset} disabled={disabled}>Zurücksetzen</Button>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Collapse>
        </>
    );
}
